// AUTO-GENERATED by tools/generate-parallel.mjs --world 14. Do not edit by hand.
// Regenerate with: node tools/generate-parallel.mjs --world 14
// W14 (Ballast) — fourth expansion, gravity cells. Tiles re-slide on landing.
// // First cell-attribute mechanic. d=8-10 band; 1-3 gravity cells per board.
import type { LevelDef } from '@tessera/engine';

export const WORLD_14_GENERATED: LevelDef[] = [
  // d*=8  branching=19.24  D=0.091  tiles=12
  {
    id: 'w14-l01',
    world: 14,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    gravity: [
      { coord: { q: 0, r: 3 }, direction: 'W' },
    ],
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 3 },
    { coord: { q: 1, r: -3 }, color: 3 },
    ],
  },
  // d*=8  branching=21.75  D=0.099  tiles=12
  {
    id: 'w14-l02',
    world: 14,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    gravity: [
      { coord: { q: 0, r: -2 }, direction: 'E' },
    ],
    tiles: [
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: 3, r: -3 }, color: 3 },
    ],
  },
  // d*=8  branching=24.74  D=0.136  tiles=12
  {
    id: 'w14-l03',
    world: 14,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    gravity: [
      { coord: { q: 0, r: 0 }, direction: 'NE' },
    ],
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 2 },
    { coord: { q: 1, r: 2 }, color: 3 },
    { coord: { q: 2, r: 1 }, color: 3 },
    ],
  },
  // d*=8  branching=27.88  D=0.172  tiles=13
  {
    id: 'w14-l04',
    world: 14,
    index: 4,
    radius: 4,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    gravity: [
      { coord: { q: 2, r: -1 }, direction: 'W' },
      { coord: { q: -1, r: 3 }, direction: 'E' },
    ],
    tiles: [
    { coord: { q: 3, r: -4 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 4 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 4 }, color: 0 },
    { coord: { q: -2, r: 4 }, color: 0 },
    { coord: { q: -4, r: 4 }, color: 0 },
    { coord: { q: 4, r: -4 }, color: 1 },
    { coord: { q: 2, r: -4 }, color: 1 },
    { coord: { q: 0, r: 4 }, color: 2 },
    { coord: { q: 2, r: 2 }, color: 2 },
    { coord: { q: -3, r: -1 }, color: 3 },
    { coord: { q: -4, r: 0 }, color: 3 },
    ],
  },
  // d*=9  branching=20.33  D=0.302  tiles=13
  {
    id: 'w14-l05',
    world: 14,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    gravity: [
      { coord: { q: -1, r: 2 }, direction: 'W' },
      { coord: { q: -3, r: 1 }, direction: 'NE' },
    ],
    tiles: [
    { coord: { q: 2, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: 1, r: -2 }, color: 3 },
    ],
  },
  // d*=9  branching=20.94  D=0.313  tiles=13
  {
    id: 'w14-l06',
    world: 14,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    gravity: [
      { coord: { q: -3, r: 2 }, direction: 'SE' },
      { coord: { q: -1, r: -2 }, direction: 'E' },
    ],
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -2, r: -1 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: 0, r: 3 }, color: 2 },
    { coord: { q: 0, r: -3 }, color: 3 },
    { coord: { q: 1, r: -3 }, color: 3 },
    ],
  },
  // d*=9  branching=21.44  D=0.318  tiles=13
  {
    id: 'w14-l07',
    world: 14,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    gravity: [
      { coord: { q: 1, r: 0 }, direction: 'W' },
      { coord: { q: 1, r: 2 }, direction: 'SW' },
    ],
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 3 },
    { coord: { q: -3, r: 1 }, color: 3 },
    ],
  },
  // d*=9  branching=21.93  D=0.339  tiles=13
  {
    id: 'w14-l08',
    world: 14,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    gravity: [
      { coord: { q: 0, r: 0 }, direction: 'SW' },
      { coord: { q: 0, r: -2 }, direction: 'NE' },
    ],
    tiles: [
    { coord: { q: -1, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: -3, r: 0 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 3 },
    { coord: { q: 3, r: -2 }, color: 3 },
    ],
  },
  // d*=9  branching=23.45  D=0.344  tiles=13
  {
    id: 'w14-l09',
    world: 14,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    gravity: [
      { coord: { q: -1, r: -1 }, direction: 'SW' },
      { coord: { q: -1, r: 1 }, direction: 'W' },
    ],
    tiles: [
    { coord: { q: -1, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 2 },
    { coord: { q: -3, r: 0 }, color: 3 },
    { coord: { q: -3, r: 2 }, color: 3 },
    ],
  },
  // d*=9  branching=26.45  D=0.357  tiles=13
  {
    id: 'w14-l10',
    world: 14,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 11 },
    gravity: [
      { coord: { q: 0, r: -1 }, direction: 'E' },
      { coord: { q: 3, r: -3 }, direction: 'SE' },
    ],
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: -3, r: 1 }, color: 3 },
    { coord: { q: -3, r: 0 }, color: 3 },
    ],
  },
];
